<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, computed} from 'vue';

/*==================================================================*/
/*=============== COMPONENTES IMPORTS ==============================*/
/*==================================================================*/

import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoTextoBase from '@/components/v2/base/CampoTextoBase/CampoTextoBase.vue';
import CampoMoneyBase from '@/components/v2/base/CampoMoneyBase/CampoMoneyBase.vue';
import CampoDataBase from '@/components/v2/base/CampoDataBase/CampoDataBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    dado: {
        type: Object,
        default: () => ({})
    },
    pagamento: {
        type: Object,
        default: () => ({})
    },
});

/*==================================================================*/
/*=========== Mostra Data de Previsão de Pagamento =================*/
/*==================================================================*/

const mostraDataPrevisaoDePagamento = computed(()=>{

    // Se for Diferente de Boleto
    if(props?.dado?.formaDePagamento != "Boleto") {
        return false;
    }

    return true;

});

</script>

<template>

    <CartaoBase>

        <template #header>

            <div class="c-header">

                <span class="c-header__titulo">Pagamento</span>

            </div>

        </template>

        <template #body>

            <div class="c-body">

                <CampoTextoBase
                    label="Descrição"
                    :value="props.pagamento?.descricao"
                    disabled
                ></CampoTextoBase>

                <CampoMoneyBase
                    label="Valor do Pagamento"
                    :value="props.pagamento?.valor"
                    disabled
                ></CampoMoneyBase>

                <CampoDataBase
                    label="Data de Criação"
                    :value="props.pagamento?.dataCriacao"
                    disabled
                ></CampoDataBase>

                <CampoDataBase
                    v-show="mostraDataPrevisaoDePagamento"
                    label="Data de Previsão de Pagamento"
                    :value="props.pagamento?.dataDoPagamento"
                    disabled
                ></CampoDataBase>

            </div>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Card ==========================================*/
/*==================================================================*/

.c-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 600;
}

.c-body {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

@media (max-width: 960px) {
    .c-body {
        grid-template-columns: 1fr;
    }
}

</style>
